import React from 'react';
import { object, number } from 'yup';

import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from './FormResource.jsx';

const defaults = {
  orgId: 0,
  name: '',
  showroom: '',
  fax: '',
  tel: '',
  address1: '',
  address2: '',
  currency: '',
  email: '',
  countryCode: '',
  showrmCode: '',
  isShowrm: false,
  discount: 100,
  erpCode: '',
};

const schema = object({
  discount: number().label('Max Discount Percentage').range(0, 100).required(),
});

const FormShowroom = ({ showroom }) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: showroom
        ? {
          ...showroom,
          currency: showroom.currency.join(','),
        }
        : undefined,
      api: '/api/core/showrooms',
      onSubmit: (v) => {
        v.currency = v.currency.split(',').map((x) => String(x).trim());
        return v;
      },
    }}>
    <div className="row">
      <div className="col">
        <FormGroup name="orgId" label="Organization ID" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="name" label="Company Name" />
      </div>
      <div className="col">
        <FormGroup name="showroom" label="Showroom Name" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="fax" />
      </div>
      <div className="col">
        <FormGroup name="tel" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="address1" label="Address Line 1" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="address2" label="Address Line 2" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="currency" label="Currency (Comma separated)" />
      </div>
      <div className="col">
        <FormGroup name="email" label="Email" />
      </div>
    </div>
    <FormGroup name="discount" type="number" label="Max Discount Percentage (%)" />
    <div className="row">
      <div className="col">
        <FormGroup name="countryCode" />
      </div>
      <div className="col">
        <FormGroup name="showrmCode" />
      </div>
      <div className="col">
        <label>Is Showrm</label>
        <FormCheckGroup name="isShowrm" type="checkbox" label="" asSwitch />
      </div>
      <div className="col">
        <FormGroup name="erpCode" />
      </div>
    </div>
  </FormResource>
);

export default FormShowroom;
